import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, RefreshCw } from 'lucide-react';
import { fadeInUp } from '../utils/animations';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-gray-50 via-blue-50/30 to-gray-50 flex items-center justify-center p-4 overflow-hidden">
      {/* Subtle Animated Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          className="absolute top-20 left-10 w-64 h-64 bg-blue-400/8 rounded-full blur-3xl"
          animate={{
            y: [-10, 10, -10],
            transition: {
              duration: 8,
              repeat: Infinity,
              ease: 'easeInOut',
            },
          }}
        />
        <motion.div
          className="absolute bottom-40 right-20 w-80 h-80 bg-cyan-400/8 rounded-full blur-3xl"
          animate={{
            y: [10, -10, 10],
            transition: {
              duration: 10,
              repeat: Infinity,
              ease: 'easeInOut',
            },
          }}
        />
        <motion.div
          className="absolute top-1/2 left-1/2 w-72 h-72 bg-purple-400/5 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.3, 0.5, 0.3],
            transition: {
              duration: 12,
              repeat: Infinity,
              ease: 'easeInOut',
            },
          }}
        />
      </div>

      <motion.div
        className="relative bg-white rounded-xl shadow-lg max-w-lg w-full p-8 text-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', duration: 0.5 }}
        >
          <XCircle className="w-10 h-10 text-red-600" />
        </motion.div>

        <motion.h1
          className="text-2xl font-bold text-gray-900 mb-4"
          variants={fadeInUp}
          initial="initial"
          animate="animate"
        >
          Plată anulată
        </motion.h1>

        <motion.p
          className="text-gray-600 mb-8"
          variants={fadeInUp}
          initial="initial"
          animate="animate"
        >
          Procesul de plată a fost anulat sau a întâmpinat o eroare. Nicio sumă
          nu a fost debitată din contul dumneavoastră.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <motion.button
            onClick={() => navigate('/pacient')}
            className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Înapoi la consultații
          </motion.button>

          <motion.button
            onClick={() => navigate('/pacient')}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-[#024994] text-white rounded-lg hover:opacity-90 transition"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <RefreshCw className="w-5 h-5" />
            Reîncercați plata
          </motion.button>
        </motion.div>
      </motion.div>
    </div>
  );
}
